import React, { useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';
import { useRouteAccessList } from '@hooks';

const PrivateReportsRoutes = ({ t,alert }) => {

    const [access, setAccess] = useState([]);

    useRouteAccessList((res) => {
        setAccess(res.data.route_name);
    });

    const ViewPrivateReports = loadable(() => import('./ViewPrivateReports'), {
        fallback: <Loader />
    });

    const EmpSpecificAttendanceReport = loadable(() => import('./EmpSpecificAttendanceReport'), {
        fallback: <Loader />
    });

    return (
        <div>
            <Routes>
                <Route index exact path="/view" element={<ViewPrivateReports t={t} access={access} alert={alert} />} />
                <Route path="/emp-specific-attendance" element={<EmpSpecificAttendanceReport t={t} access={access} alert={alert} />} />
                <Route path="*" element={<Navigate replace to="/404" />} />
            </Routes>
        </div>
    )
}

export default PrivateReportsRoutes
